const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/

export const getYouTubeVideoIdFromUrl = (url: string) => {
  const match = regExp.exec(url)
  return match && match[1].length === 11 ? match[1] : undefined
}
